import axios from 'axios';
import { getAxiosConfig } from '../../lib/auth';
import { API_URL } from '../../lib/const';


const fetchContract = token => axios.get(`${API_URL}/contracts/enrollment/${token}`, getAxiosConfig())
  .then(response => response.data);

export default fetchContract;
